export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Warning-Gray-3d5529e45bc257d0956c1f7d02ded12d.svg";